function klevu_afterLandingResultsLoaded() {
  console.log('results loaded', document.querySelectorAll('.klevuImgWrap a img'));

 
const limitedEditionProducts = [];

if (window.location.pathname.includes('/search-results')) {
  const results = document.querySelectorAll('.klevuImgWrap a');

  results.forEach(result => {
    let productHandle = result.getAttribute('href').split('/').pop();

    // Fetch product tags for each product handle
    fetchProductTags(productHandle, result);
  });

  async function fetchProductTags(productHandle, resultElement) {
    const storefrontAccessToken = '3e3bf7082bbe85e14b3cd9294de962d5';
    const shopifyStoreDomain = 'mia-shoes-store.myshopify.com';

    // Constructing the GraphQL query with specific product handle
    const query = `
    {
      product(handle: "${productHandle}") {
        tags
      }
    }`;

    try {
      const response = await fetch(`https://${shopifyStoreDomain}/api/2024-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();

      // Access the product data directly
      const product = data.data.product;

      // Check if product tags include 'MLE'
      if (product && product.tags.includes('MLE')) {
        // Find the relevant element to append the "Limited Edition" badge
        const nameDescElement = resultElement.querySelector('img')
        
        if (nameDescElement) {
          nameDescElement.insertAdjacentHTML('beforebegin', '<div class="kuSubname search">Limited Edition</div>');
        } else {
          resultElement.querySelector('img').prepend('<div class="kuSubname search">Limited Edition</div>');
        }

      } 

    } catch (error) {
      console.error('Error fetching product tags:', error);
    }
  }
}





  // REODER Size facet
  var sizeFacetLabelArr = document.querySelectorAll('#kuFilterNames-size ul li a');
  var sizeOrderedArray = ["1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "XS", "M", "060M"];

  function defineSizeOrder(sizeFacetLabel_item) {
    for (var k = 0; k < sizeOrderedArray.length; k++) { // loop through all size variants
      var sizeOrdered_item = sizeOrderedArray[k].toLowerCase();

      if (sizeFacetLabel_item.getAttribute("title").toLowerCase() === sizeOrdered_item) {
        sizeFacetLabel_item.parentElement.style.order = (k + '');
        break;
      } else {
        sizeFacetLabel_item.parentElement.style.order = '200';
      }
    }
  }

  // loop thrugh all size DOM-elements
  for (var i = 0; i < sizeFacetLabelArr.length; i++) {
    var sizeFacetLabel = sizeFacetLabelArr[i];
    defineSizeOrder(sizeFacetLabel);
  }

  // Final Sale Collection Badge
  const imgWraps = document.querySelectorAll('.klevuImgWrap a');
  const saleBadge = document.createElement('div');
  saleBadge.classList.add('sale-badge','collection');

  saleBadge.innerHTML = 'Final Sale';
    if (window.location.pathname.includes('collections/sale')) {
        imgWraps.forEach(imgWrap => {
            imgWrap.appendChild(saleBadge.cloneNode(true));
      });
    } 
}




$(window).on("load", function () {
  var sortEl = document.getElementById('kuSortby');
  var myInterval = setInterval(checkingLoadingKlevu, 100);
  var klevuElement = '.klevuImgWrap a';


  function checkingLoadingKlevu() {
    if ($(document.querySelectorAll(klevuElement)).length > 0) {
      stopCheckingLoadingKlevu();

      if (window.location.pathname.includes('collections/new-arrivals')) {
        sortEl.value = 'NEW_ARRIVAL_DESC';
      } else {
        sortEl.value = 'NAME_ASC';
      }

      sortEl.dispatchEvent(new Event('change'));
    }
  }

  function stopCheckingLoadingKlevu() {
    clearInterval(myInterval);
  }
});
